<!-- START SERVICES -->
<style>
    @media only screen and (max-width: 479px) {
  
    .sect-exp {
      background-image: url("./assets/images/cartographer.png") !important;
      position: relative;
    background-size: auto;
      background-repeat: repeat;
    }
}
 @media only screen and (min-width: 479px) {
  
        .sect-exp{
    background-image: url("./assets/images/FONDO.png");
  position: relative;
  padding: 190px 0;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;}
}

  #plnt1{
    /* width: 10%;
    object-fit: cover;
  object-position: 50% 10%; */
background-image: url("./assets/images/planets/planet1.png");
  background-position: bottom 20px right 100px;
  background-repeat: no-repeat;
  background-size: 120px;
  height: 320px;
  width: auto;
    }
</style>
<section class="section sect-exp" id="services">
   
    
    <div id="" class="container">
        
        <div class="row justify-content-center text-center">
            <div class="col-lg-12">
                
                <div class="text-center">
                    <h1 class="fontl text-white home-title mb-0" style="font-size: 32px; letter-spacing: 10px;text-shadow: 0 0 1px black;">EXPOCOMUNICARTE 2023
                    </h1>
                    
                    
                    
                </div>
                <!-- <h2 class="title titlet">EXPOCOMUNICARTE <span class="fw-bold">2023</span></h2> -->
                <h3 class="text-muted mt-3 title-subtitle mx-auto" style="text-shadow: 0 0 1px black; color: white !important;">La Feria Académica más importante de Manabí</h3>
                <p class="pdtxt text-white" style="text-shadow: 0 0 1px black;"> Exposiciones llamativas, muestras impecables, ambiente festivo y un derroche de conocimientos es lo que se vive en la
                Expocomunicarte. Este es el evento académico que la Universidad Particular San Gregorio de Portoviejo prepara cada año
                para la comunidad.</p>

            </div>
        </div>
        <!-- <div class="row mt-5">
            <div class="col-md-4" *ngFor="let item of servicesData">
                <div class="services-box">
                    <div class="services-icon">
                        <i :class="{{item.icon}} text-primary"></i>
                    </div>
                    <div class="mt-3">
                        <h5 class="services-title fw-bold mb-3">{{item.title}}</h5>
                        <p class="services-subtitle text-muted"> Ut enim ad minim veniam, quis nostrud exercitation
                            ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- end row -->
    </div>
    
</section>
<!-- END SERVICES -->